export default "__VITE_ASSET__1ddEqVUj__"